import React from "react";
import { Route, Routes } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useAuthorization } from "@common/providers";
import { useGetProjectByIdQuery, useWhoAmIQuery } from "@generated";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import useListPaymentCredits from "./api/useListPaymentCredits";
import Show from "./Show/Show";
import Edit from "./Edit/Edit";
import New from "./New/New";

interface Props {
  project_id: string;
}

const PaymentCreditsV2Mspa: React.FC<Props> = ({ project_id }) => {
  const projectId = project_id;
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data: project, isLoading: projectLoading } =
    useGetProjectByIdQuery({
      id: projectId as any,
      slug: accountSlug,
    });

  const { data: currentUser, isLoading: currentUserLoading } =
    useWhoAmIQuery();

  const { paymentCredits, paymentCreditsMap, paymentCreditsLoading } =
    useListPaymentCredits();

  const authorized = useAuthorization();

  if (
    !authorized ||
    projectLoading ||
    currentUserLoading ||
    paymentCreditsLoading ||
    !project ||
    !currentUser
  ) {
    return <ScopeStackSpinner />;
  }

  const projectStatus = project?.data?.attributes?.status || "";
  const currencyUnit =
    (project?.data?.attributes as any)?.["field-labels"]?.currency_unit || "$";
  const privileges = currentUser?.data?.attributes?.privileges || [];
  const permission =
    privileges.find((p) => p.privilege === "projects.payment_credits")?.[
      "access-level"
    ] || "view";

  return (
    <div className="tab-content">
      <div className="tab-pane active">
        <Routes>
          <Route
            path="/"
            element={
              <Show
                projectId={projectId}
                projectStatus={projectStatus}
                permission={permission}
                currencyUnit={currencyUnit}
                paymentCreditsMap={paymentCreditsMap}
              />
            }
          />
          <Route
            path="/edit/:creditId"
            element={
              <Edit
                projectId={projectId}
                permission={permission}
                projectStatus={projectStatus}
                paymentCredits={paymentCredits}
              />
            }
          />
          <Route
            path="/new"
            element={
              <New
                projectId={projectId}
                permission={permission}
                projectStatus={projectStatus}
                paymentCredits={paymentCredits}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default PaymentCreditsV2Mspa;
